import { createFileRoute } from '@tanstack/react-router'
import AssessmentsIndex from '@/pages/assessments'

export const Route = createFileRoute('/_authenticated/assessments/')({
  component: AssessmentsIndex,
})
